import { createSelector } from 'reselect'

const getCurrentUser = state => state.currentUser

const formatUserRole = category => (category === 'ADMIN' ? 'offerzen_user' : category.toLowerCase())

export const errorUser = createSelector([getCurrentUser], user => {
  if (!user || !user.id) return {}

  return {
    id: user.id,
    name: user.name,
    email: user.email,
    role: formatUserRole(user.category),
  }
})

export const userRole = createSelector([getCurrentUser], user => formatUserRole(user.category))
export const currentUser = createSelector([errorUser], user => user)
